<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.1426 10.3446L7.14258 13.6893V7L13.1426 10.3446Z" fill="currentColor"/>
</svg>
